var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.923828,
    y: 0.277832,
    width: 12,
    height: 12,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3284_5426",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3284_5426",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpElEQVR4nO2dvWoUYRiFn9irhWDA6iu1VrD1BtIGUSRb2dmowVYhhSC2QgLydmn0DkLSiTehRRpBryD+MTIwAYudyWZ3Npzv3fPA2+wMM99zzs7uNjsDxhhjjDHGGGOMMcaYMVkDJsCLOWfSHcOMwCVgD2gWnL3uWGYB1oB3I5RxOu9XqZQbwOORZ3/EMk5nfwnrbN3luLeE8JpKpnWXw4WsaCF/gUPg4Iw57Pb1FbLkMrbO8Sa5D/zxR5ZGGRdZiuR3yF3gazfHA4s//m+/WecLsLnA2ja7Y5z3vLN6tO7SlAGRdlstlCQeaURKEo80IiWJRxqRksQjjUhJ4pFGpCTxSCNSknikESlJPNKIlCQeaURKEo80IiWJRxqRksRjLpEJsDtl2tenca1n/91u2xjnWOlComf/qOwckqiGFS5EK6xwIVphhQvRCitciFZY4UK0wgoXohVWuBCtsMKFaIUVLkQrrHAhWmGFC9EKK1yIVljhQrTCCheiFVa4EK2wwoVohRUuRCuscCFaYYUL0QorXIhWWOFCtMIKF6IVVrgQrbDChWiFFS5EK6xwIVphhQvRCitciFZY4UK0wgoXohVWuBCtsMKFzB7Wds+d4drXp7E+cDe59ZHOsdJ/2FEki0cakZLEI41ISeKRRqQk8UgjUpJ4pBEpSTzSiJQkHmlEShKPNCIliQfXB0RuUw93Bjxax2poH5ryq0fkJfXwqsfhZ42PUPrcI3MCPECfh91apzl8okK2By73dr4BRzM8duLggueoW9vQ2p9RIZeB72eI1Tg/gCtUypZAgM3I84jKeSsQYjPSvCEJz4HfAoE2c0679qck4xbwsfvJ2FQyJ8AH4CaJuQpsAE+AHeC12Ox0a9uo+cvbGGOMMcYYY4wxxhiWzD9ynTd24pr7CQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/Trash Can.34037538d61eec44a357526c9b7d2817.svg";
export { ForwardRef as ReactComponent };